module.exports = require("./mfe.js");